var encodeCustomizable = (model, _ref) => {
  var {
    seats,
    functionality,
    armrests,
    feet,
    coatings,
    comfort
  } = _ref;
  return [model, seats.code, functionality.code, armrests.code, feet.code, coatings.code, comfort.code].join('');
};
export default encodeCustomizable;